import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import styled from 'styled-components';
import Text from './Text';
export var StyledParagraph = /*#__PURE__*/styled(Text).withConfig({
  displayName: "StyledParagraph",
  componentId: "c11n-8-64-0__sc-18ze78a-0"
})([""]);
/**
 * A block level alias for the [`<Text>`](#/Typography%20components?id=text) component and
 * is equivalent to `<Text as="p" fontType="body">`.
 *
 * @since 6.0.0
 */

var Paragraph = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(StyledParagraph, _extends({
    as: "p",
    fontType: "body",
    ref: ref
  }, props));
});
Paragraph.displayName = 'Paragraph';
export default Paragraph;